import {
    BootState,
    getAllMailAccountSources,
    getGlobalSettingsAccount,
    getGlobalSettingsAccountMailboxInfo,
} from 'owa-account-source-list-store';
import { MailFolderTreesParentContainer } from 'owa-mail-folder-tree-container-view';
import TreeNode from 'owa-tree-node/lib/components/TreeNode';
import React from 'react';
import classnames from 'owa-classnames';
import { full, medium, compact, paddedContainer } from './AccountsList.scss';
import { getDensityModeCssClass } from 'owa-fabric-theme';

export const GlobalSettingsAccountFolderNodeWithDummyList =
    function GlobalSettingsAccountFolderNodeWithDummyList(): React.JSX.Element {
        const accountSources = getAllMailAccountSources();
        const globalSettingsAccountSource = getGlobalSettingsAccount();
        const densityModeCssClass = getDensityModeCssClass(full, medium, compact);

        // The pre-render work for the global settings account happens in startup
        const globalSettingsBootState = BootState.StartupComplete;
        const chevronProps = React.useMemo(() => {
            return { isExpanded: false, onClick: () => {} };
        }, []);

        return (
            <>
                <div className={classnames(paddedContainer, densityModeCssClass)}>
                    <MailFolderTreesParentContainer
                        favoritesNodeCount={1}
                        accountMailboxInfo={getGlobalSettingsAccountMailboxInfo()}
                        accountBootState={globalSettingsBootState}
                    />
                </div>
                {accountSources
                    .filter(
                        accountSource =>
                            accountSource.sourceId !== globalSettingsAccountSource.sourceId
                    )
                    .map(accountSource => (
                        <div
                            className={classnames(paddedContainer, densityModeCssClass)}
                            key={accountSource.sourceId}
                        >
                            <TreeNode
                                chevronProps={chevronProps}
                                displayName={accountSource.mailboxInfo.mailboxSmtpAddress}
                                depth={0}
                                isRootNode={true}
                                key={accountSource.sourceId}
                                isDroppedOver={false}
                            />
                        </div>
                    ))}
            </>
        );
    };
